export default {
  brand: {
    fileShare: '파일 공유'
  },
  common: {
    loading: '로딩 중...',
    confirm: '확인',
    cancel: '취소',
    download: '다운로드',
    downloadAll: '모두 다운로드',
    downloadSelected: '선택 항목 다운로드',
    selectAll: '전체 선택',
    deselectAll: '선택 해제',
    rootDirectory: '루트 디렉토리',
    createTime: '생성 시간',
    expireTime: '만료 시간',
    totalSize: '총 크기',
    noFiles: '파일 없음'
  },
  share: {
    expired: '공유된 파일이 만료되었습니다',
    invalidLink: '유효하지 않은 공유 링크',
    needVerifyCode: '추출 코드를 입력하세요',
    verifyCodeLabel: '코드',
    verifyCodePlaceholder: '추출 코드 입력',
    extractFiles: '파일 추출',
    extractionCodeError: '추출 코드가 잘못되었습니다',
    uuidRequestFailed: '다운로드 요청 실패',
    selectFilesFirst: '먼저 파일을 선택하세요',
    unknownError: '알 수 없는 오류'
  },
  error: {
    networkError: '네트워크 오류',
    connectionFailed: '공유 장치에 연결할 수 없습니다. 장치가 꺼져 있거나 절전 모드이거나 서비스 지역이 변경되었을 수 있습니다. 공유자에게 문의하세요.',
    outdatedLink: '공유 장치에 연결할 수 없습니다. 오래된 공유 링크가 사용되었을 수 있습니다. 공유자에게 시스템을 v2.0.10 이상, APP을 v2.1.5 이상으로 업그레이드하고 공유 링크를 다시 복사해 달라고 요청하세요.',
    registryError: '공개 네트워크 침투 설정 가져오기 오류, Registry 서비스에 연결할 수 없습니다.',
    missingRegion: '공유 링크에 서비스 지역 정보가 없습니다. 공유자에게 시스템을 v2.0.10 이상, APP을 v2.1.5 이상으로 업그레이드하고 공유 링크를 다시 복사해 달라고 요청하세요.'
  }
}
